import React, { createContext, useContext, useState } from 'react';

export const DrawerContext = createContext({ open: false, setOpen: () => {} });

export function DrawerProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <DrawerContext.Provider value={{ open, setOpen }}>
      {children}
    </DrawerContext.Provider>
  );
}

export const useDrawer = () => useContext(DrawerContext);
